import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, EditableDBItemV3, getElementCenterPos, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, ModuleFE_Toaster, mouseInteractivity_PopUp, openContent, Show, stopPropagation, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend/index';
import { ActionsMenu_BaseManagerUI, Dialog_Confirmation, ICONS } from '@app/styles';
import './Editor_Organization.scss';
import { QScrollWrapper } from '@app/hcs-frontend';
import { Editor_Organization_GeneralInformation } from './inner-editors/general-information/Editor_Organization_GeneralInformation.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { DBDef_AdvisorConfiguration, DBDef_EHRInstallation, DBDef_Environment, DBDef_Facility, DBDef_LaunchUrls, DBDef_Organization, DBDef_User, EHRInstallationTypes } from '@app/org-shared';
import { ModuleFE_AdvisorConfiguration, ModuleFE_EHRInstallation, ModuleFE_Environment, ModuleFE_Facility, ModuleFE_LaunchUrls, ModuleFE_Organization, ModuleFE_User, } from '../../../_entity.js';
import { AccessLevel, ModuleFE_PermissionsAssert } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
import { sortArray, voidFunction } from '@nu-art/ts-common';
import { Component_FocusedEntityRef } from '@nu-art/ts-focused-object-frontend/components/Component_FocusedEntityRef';
import { ModuleFE_Account } from '@nu-art/user-account-frontend';
import { Component_OrganizationUserProfile } from './inner-editors/user-profile/Component_OrganizationUserProfile.js';
import { Editor_Organization_Environments } from './inner-editors/environments/Editor_Organization_Environments.js';
import { Editor_Organization_AdvisorConfigurations } from './inner-editors/advisor-configurations/Editor_Organization_AdvisorConfigurations.js';
import { views, viewsLabelMap } from './inner-editors/types.js';
import { ModuleFE_Artifact } from '../../../_entity/artifact/index.js';
import { getConfigurationsByOrganization, getEnvironmentsByInstallation, getFacilitiesByOrganization, getInstallationsByOrganization, getLaunchURLsByOrganization, getUsersByOrganization } from './utils.js';
import { Dialog_ExportOrderMapping } from './printables/Printable_OrderMapping/Dialog_ExportOrderMapping.js';
import { Editor_Organization_Facilities } from './inner-editors/facilities/Editor_Organization_Facilities.js';
import { Editor_Organization_LaunchUrls } from './inner-editors/launch-urls/Editor_Organization_LaunchUrls.js';
import { Editor_Organization_EHRInstallations } from './inner-editors/ehr-installations/Editor_Organization_EHRInstallations.js';
export class Editor_Organization extends TS_EditableItemComponentProto {
    organizationActions = [
        {
            label: 'Edit Organization',
            action: () => this.setState({ editMode: true }),
            permissionKey: ModuleFE_Organization.permissions.collection.edit
        },
        {
            label: 'Delete Organization',
            action: this.props.deleteOrganization,
            permissionKey: ModuleFE_Organization.permissions.collection.delete,
        },
    ];
    // ######################## Lifecycle ########################
    __onEHRInstallationUpdated(...params) {
        this.forceUpdate();
    }
    ;
    __onEnvironmentUpdated(...params) {
        this.forceUpdate();
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.selectedItem ??= undefined;
        state.editMode ??= false;
        // New organization (no _id): always start in edit mode so the user can fill the form
        if (!nextProps.editable?.item._id)
            state.editMode = true;
        return state;
    }
    // ######################## Logic ########################
    selectItem = (key, item, module) => {
        if (!item._id)
            this.setState({ editMode: true });
        const editable = new EditableDBItemV3(item, module)
            .setAutoSave(!!item._id)
            .setOnChanged(async (editable) => {
            this.selectItem(key, editable.item, module);
        });
        this.setState({
            selectedItem: { type: key, editable: editable },
        });
    };
    onHeaderRightClick = (e, renderer) => {
        stopPropagation(e);
        ModuleFE_MouseInteractivity.showContent({
            id: 'pop-up-menu',
            content: renderer,
            offset: { y: 10 },
            modalPos: { x: 1, y: 1 },
            originPos: getElementCenterPos(e.currentTarget),
        });
    };
    onEntityRightClick = (e, actions) => {
        if (!actions.length)
            return;
        ModuleFE_MouseInteractivity.showContent({
            id: 'pop-up-menu',
            originPos: getElementCenterPos(e.currentTarget),
            modalPos: { x: 1, y: 1 },
            content: () => _jsx(_Fragment, { children: actions.map(action => {
                    return _jsx("div", { className: 'popup-action', onClick: action.action, children: action.label }, action.label);
                }) })
        });
    };
    getDeleteAction = (key, entity, entityName, module, deleteMessage) => {
        deleteMessage ??= `Are you sure you want to delete ${entityName}?`;
        const deleteAction = async () => {
            await module.v1.delete(entity).executeSync();
            const selectedItemId = this.state.selectedItem?.editable.item._id;
            if (selectedItemId === entity._id)
                return this.setState({ selectedItem: undefined });
            this.forceUpdate();
        };
        return {
            label: `Delete ${key} ${entityName}`,
            action: async () => {
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                Dialog_Confirmation.show({
                    header: `Delete ${key}`,
                    content: () => _jsx(_Fragment, { children: deleteMessage }),
                    buttons: [{
                            label: 'Yes, Delete', isAsync: true, action: async () => deleteAction()
                        },
                        { label: 'Don\'t Delete', isPreferred: true, action: voidFunction }]
                });
            }
        };
    };
    renderNoEntityFound = (label) => {
        return _jsx("div", { className: 'editor-organization__view non-interactive', children: `No ${label} found` });
    };
    // ######################## Logic - EHR Installation ########################
    getEHRInstallationActions = (installation) => {
        const actions = [
            {
                label: 'Export Order Mapping',
                action: async () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    Dialog_ExportOrderMapping.show({ installationId: installation._id });
                }
            },
            {
                label: 'Export Order Mapping (CSV)',
                action: async () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    Dialog_ExportOrderMapping.show({ installationId: installation._id, exportAsCsv: true });
                }
            }
        ];
        const selectedInstallation = this.state.selectedItem?.editable.item;
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Organization.permissions.collection.edit) === AccessLevel.HasAccess)
            actions.push({
                label: 'Delete Installation',
                action: async () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    Dialog_Confirmation.show({
                        header: `Delete EHR Installation ${installation.label}`,
                        content: () => _jsxs(_Fragment, { children: ["Are you sure you want to delete ", installation.label, " and all its orders and environments?"] }),
                        buttons: [{
                                label: 'Yes, Delete', isAsync: true, action: async () => {
                                    await ModuleFE_EHRInstallation._v1.deleteInstallation({ installationId: installation._id }).executeSync();
                                    if (selectedInstallation?._id === installation._id)
                                        return this.setState({ selectedItem: undefined });
                                    this.forceUpdate();
                                }
                            },
                            { label: 'Don\'t Delete', isPreferred: true, action: voidFunction }]
                    });
                }
            });
        return actions;
    };
    // ######################## Logic - Environment ########################
    getEnvironmentActions = (environment, installation) => {
        const actions = [];
        if (!installation)
            return [];
        const deleteContent = `Are you sure you want to delete ${environment.label} from ${installation.label} and all of it's config?`;
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Organization.permissions.collection.edit) === AccessLevel.HasAccess)
            actions.push(this.getDeleteAction('Environment', environment, environment.label, ModuleFE_Environment, deleteContent));
        return actions;
    };
    selectEnvironment = (ehrInstallation, environment) => {
        if (!ehrInstallation._id) {
            ModuleFE_Toaster.toastError('Cannot create an environments without EHR Installation');
            return;
        }
        const newEnvironment = {
            ehrInstallationId: ehrInstallation._id,
            type: ehrInstallation.type,
            label: 'New',
        };
        environment ??= newEnvironment;
        this.selectItem(DBDef_Environment.dbKey, environment, ModuleFE_Environment);
    };
    // ######################## Logic - Configuration ########################
    getConfigurationActions = (configuration) => {
        const actions = [];
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Organization.permissions.collection.edit) === AccessLevel.HasAccess) {
            actions.push(this.getDeleteAction('Advisor Configuration', configuration, configuration.label, ModuleFE_AdvisorConfiguration));
        }
        return actions;
    };
    updateAllConfigurationsToLatestKBVersion = async () => {
        const organizationId = this.state.editable.item._id;
        if (!organizationId)
            return;
        const configurations = getConfigurationsByOrganization(organizationId);
        if (!configurations.length) {
            ModuleFE_Toaster.toastInfo('No configurations to update');
            return;
        }
        const artifacts = ModuleFE_Artifact.cache.all();
        if (!artifacts.length) {
            ModuleFE_Toaster.toastError('No artifacts found');
            return;
        }
        const latestArtifact = sortArray([...artifacts], artifact => artifact.__created, true)[0];
        const updatedConfigurations = configurations.map(config => ({
            ...config,
            kbVersionId: latestArtifact._id
        }));
        try {
            await ModuleFE_AdvisorConfiguration.v1.upsertAll(updatedConfigurations).executeSync();
            ModuleFE_Toaster.toastSuccess(`Updated ${configurations.length} configuration(s) to KB version ${latestArtifact.dataVersion}`);
        }
        catch (err) {
            ModuleFE_Toaster.toastError('Failed to update configurations');
            this.logError(err);
        }
    };
    // ######################## Logic - Facility ########################
    getFacilityActions = (facility) => {
        const actions = [];
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Organization.permissions.collection.edit) === AccessLevel.HasAccess) {
            actions.push(this.getDeleteAction('Facility', facility, facility.name, ModuleFE_Facility));
        }
        return actions;
    };
    // ######################## Logic - Launch URLs ########################
    getLaunchUrlsActions = (launchUrl) => {
        const actions = [];
        const editable = new EditableDBItemV3(launchUrl, ModuleFE_LaunchUrls);
        if (ModuleFE_PermissionsAssert.getAccessLevel(ModuleFE_Organization.permissions.collection.edit) === AccessLevel.HasAccess)
            actions.push({
                label: 'Delete Launch Url',
                action: async () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    Dialog_Confirmation.show({
                        header: `Delete Launch Url ${launchUrl.label}`,
                        content: () => _jsxs(_Fragment, { children: ["Are you sure you want to delete ", launchUrl.label, " and its short url?"] }),
                        buttons: [{
                                label: 'Yes, Delete', isAsync: true, action: async () => {
                                    await editable.delete();
                                    this.forceUpdate();
                                }
                            },
                            { label: 'Don\'t Delete', isPreferred: true, action: voidFunction }]
                    });
                }
            });
        return actions;
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'quai-item-manager', id: 'editor-organization', children: [this.renderHeader(), this.renderBody()] });
    }
    // ######################## Render - Header ########################
    renderHeader = () => {
        const className = _className('manager__header', this.state.editMode && 'edit-mode');
        const org = this.state.editable.item;
        const title = org.alias ? org.alias : org.name;
        const subtitle = org.alias ? org.name : undefined;
        return _jsx(LL_H_C, { className: className, children: _jsxs(LL_H_C, { className: 'manager__header__main', children: [_jsx(LL_V_L, { className: 'manager__header__title', children: _jsxs(Show, { children: [_jsxs(Show.If, { condition: !!org._id, children: [_jsx("div", { className: 'manager__header__title__label', children: title }), _jsx("div", { className: 'manager__header__sub-title', children: subtitle })] }), _jsx(Show.Else, { children: _jsx("div", { className: 'manager__header__title__label', children: "Add New Organization" }) })] }) }), this.renderHeaderTail()] }) });
    };
    renderHeaderTail = () => {
        const editMode = !!this.state.editMode;
        const itemId = this.state.editable?.item._id;
        const focusedEntity = itemId ? {
            dbKey: DBDef_Organization.dbKey,
            itemId: itemId
        } : undefined;
        return _jsxs(Show, { children: [_jsx(Show.If, { condition: !editMode && !!itemId, children: _jsx(ICONS.more.component, { className: 'editor-organization__header__main__more', ...openContent.popUp.bottom('pop-up__organization-action', this.renderActionMenu, 10) }) }), _jsx(Show.If, { condition: !!itemId, children: _jsx(Component_FocusedEntityRef, { focusedEntities: [focusedEntity] }, itemId) }), _jsx(Show.If, { condition: editMode && !!itemId, children: _jsx(LL_H_C, { className: 'editor-organization__header__tail', children: _jsx(Button, { variant: 'primary', className: 'preferred-action', onClick: () => this.setState({ editMode: false }), children: "Done" }) }) }), _jsx(Show.If, { condition: editMode && !itemId, children: _jsxs(LL_H_C, { className: 'editor-organization__header__tail', children: [_jsx(Button, { variant: 'secondary', onClick: this.props.deselectOrganization, children: "Cancel" }), _jsx(Button, { variant: 'primary', className: 'preferred-action', onClick: () => this.state.editable.save(), children: "Save" })] }) })] });
    };
    renderActionMenu = () => {
        return _jsx(ActionsMenu_BaseManagerUI, { actions: this.organizationActions });
    };
    // ######################## Render - Views ########################
    renderBody = () => {
        return _jsxs(LL_H_C, { className: 'editor-organization__body', children: [this.renderSelector(), this.renderEditor()] });
    };
    renderSelector = () => {
        return _jsx(QScrollWrapper, { className: 'editor-organization__views', children: views.map(view => {
                if (view !== 'general-information' && !this.state.editable.item._id)
                    return;
                if (view === 'ehr-installations')
                    return this.renderInstallationView();
                if (view === 'users')
                    return this.renderUserMenu();
                if (view === 'advisor-configurations')
                    return this.renderConfigurationView();
                if (view === 'facility')
                    return this.renderFacilityView();
                if (view === 'launch-urls')
                    return this.renderLaunchUrlsView();
                const selectedItemType = this.state.selectedItem?.type;
                // default renderer
                const className = _className('editor-organization__view', (selectedItemType === view || !selectedItemType && view === 'general-information') && 'selected');
                return _jsx("div", { className: className, onClick: () => {
                        if (view === 'general-information')
                            this.setState({ selectedItem: undefined });
                    }, children: viewsLabelMap[view] }, view);
            }) });
    };
    renderInstallationView = () => {
        return _jsx(TS_CollapsableContainerV2, { forceUpdate: true, animated: true, headerRenderer: () => _jsxs(_Fragment, { children: [viewsLabelMap[DBDef_EHRInstallation.dbKey], _jsx(ICONS.more.component, { ...openContent.popUpV2.bottom({
                            id: 'pop-up-menu',
                            content: this.renderEHRInstallationsMenu,
                            offset: 10
                        }) })] }), onHeaderRightClick: e => this.onHeaderRightClick(e, this.renderEHRInstallationsMenu), containerRenderer: () => {
                const organizationId = this.state.editable.item._id;
                if (!organizationId)
                    return;
                const installations = getInstallationsByOrganization(organizationId);
                const selectedItem = this.state.selectedItem?.editable.item;
                const selectedInstallation = installations.find(installation => installation._id === selectedItem?._id);
                const newInstallation = this.state.selectedItem?.type === DBDef_EHRInstallation.dbKey && !selectedItem?._id;
                if (!installations.length && !newInstallation)
                    return this.renderNoEntityFound('ehr installations');
                return _jsxs(_Fragment, { children: [newInstallation &&
                            _jsx("div", { className: 'editor-organization__view selected', children: selectedItem.label }, '##NewInstallation##'), installations.map(installation => {
                            const selected = installation._id === selectedInstallation?._id;
                            const className = _className('editor-organization__view', selected && 'selected');
                            return (_jsx(TS_CollapsableContainerV2, { forceUpdate: true, animated: true, headerRenderer: () => _jsx("div", { className: className, onClick: () => this.selectItem(DBDef_EHRInstallation.dbKey, installation, ModuleFE_EHRInstallation), onContextMenu: e => this.onEntityRightClick(e, this.getEHRInstallationActions(installation)), children: installation.label }), containerRenderer: () => this.renderEnvironmentView(installation) }, installation._id));
                        })] });
            } }, DBDef_EHRInstallation.dbKey);
    };
    renderEnvironmentView = (installation) => {
        const environments = getEnvironmentsByInstallation(installation._id);
        const selectedEnvironment = this.state.selectedItem?.editable.item;
        const newEnvironment = this.state.selectedItem?.type === DBDef_Environment.dbKey && !selectedEnvironment?._id;
        return _jsx(TS_CollapsableContainerV2, { forceUpdate: true, animated: true, headerRenderer: () => _jsxs(_Fragment, { children: ["Environments", _jsx(ICONS.more.component, { ...openContent.popUpV2.bottom({
                            id: 'pop-up-menu',
                            content: this.renderEnvironmentsMenu(installation),
                            offset: 10
                        }) })] }), onHeaderRightClick: e => this.onHeaderRightClick(e, () => this.renderEnvironmentsMenu(installation)), containerRenderer: () => {
                if (!environments.length && !newEnvironment)
                    return this.renderNoEntityFound('environments');
                return _jsxs(_Fragment, { children: [newEnvironment &&
                            _jsx("div", { className: 'editor-organization__view selected', children: selectedEnvironment.label }, '##NewEnvironment##'), environments.map(env => {
                            const selected = env._id === selectedEnvironment?._id;
                            const className = _className('editor-organization__view sub-item', selected && 'selected');
                            return _jsx("div", { className: className, onClick: () => {
                                    this.selectEnvironment(installation, env);
                                }, onContextMenu: e => this.onEntityRightClick(e, this.getEnvironmentActions(env, installation)), children: env.label }, env._id);
                        })] });
            } }, `env-${installation._id}`);
    };
    renderConfigurationView = () => {
        const configurations = getConfigurationsByOrganization(this.state.editable.item._id);
        const selectedItem = this.state.selectedItem?.editable.item;
        const selectedConfiguration = selectedItem && configurations.find(configuration => configuration._id === selectedItem?._id);
        const newConfiguration = this.state.selectedItem?.type === DBDef_AdvisorConfiguration.dbKey && !selectedConfiguration?._id;
        return _jsx(TS_CollapsableContainerV2, { animated: true, forceUpdate: true, headerRenderer: () => _jsxs(_Fragment, { children: [viewsLabelMap['advisor-configurations'], _jsx(ICONS.more.component, { ...openContent.popUpV2.bottom({
                            id: 'pop-up-menu',
                            content: this.renderConfigurationMenu,
                            offset: 10
                        }) })] }), onHeaderRightClick: e => this.onHeaderRightClick(e, this.renderConfigurationMenu), containerRenderer: () => {
                if (!configurations.length && !newConfiguration)
                    return this.renderNoEntityFound('configurations');
                return _jsxs(_Fragment, { children: [newConfiguration &&
                            _jsx("div", { className: 'editor-organization__view selected', children: selectedItem?.label }, 'NewConfiguration'), configurations.map(configuration => {
                            const selected = configuration._id === this.state.selectedItem?.editable.item._id;
                            const className = _className('editor-organization__view', selected && 'selected');
                            return _jsx("div", { className: className, onClick: () => this.selectItem(DBDef_AdvisorConfiguration.dbKey, configuration, ModuleFE_AdvisorConfiguration), onContextMenu: e => this.onEntityRightClick(e, this.getConfigurationActions(configuration)), children: configuration.label }, configuration._id);
                        })] });
            } }, DBDef_AdvisorConfiguration.dbKey);
    };
    renderFacilityView = () => {
        const facilities = getFacilitiesByOrganization(this.state.editable.item._id);
        const selectedItem = this.state.selectedItem?.editable.item;
        const selectedFacility = selectedItem && facilities.find(facility => facility._id === selectedItem?._id);
        const newFacility = this.state.selectedItem?.type === DBDef_Facility.dbKey && !selectedFacility?._id;
        return _jsx(TS_CollapsableContainerV2, { animated: true, forceUpdate: true, headerRenderer: () => _jsxs(_Fragment, { children: [viewsLabelMap['facility'], _jsx(ICONS.more.component, { ...openContent.popUpV2.bottom({
                            id: 'pop-up-menu',
                            content: this.renderFacilityMenu(),
                            offset: 10
                        }) })] }), onHeaderRightClick: e => this.onHeaderRightClick(e, this.renderFacilityMenu), containerRenderer: () => {
                if (!facilities.length && !newFacility)
                    return this.renderNoEntityFound('facilities');
                return _jsxs(_Fragment, { children: [newFacility &&
                            _jsx("div", { className: 'editor-organization__view selected', children: selectedItem.name }, 'NewFacility'), facilities.map(facility => {
                            const selected = facility._id === this.state.selectedItem?.editable.item._id;
                            const className = _className('editor-organization__view', selected && 'selected');
                            return _jsx("div", { className: className, onClick: () => this.selectItem(DBDef_Facility.dbKey, facility, ModuleFE_Facility), onContextMenu: e => this.onEntityRightClick(e, this.getFacilityActions(facility)), children: facility.name }, facility._id);
                        })] });
            } }, DBDef_Facility.dbKey);
    };
    renderLaunchUrlsView = () => {
        const launches = getLaunchURLsByOrganization(this.state.editable.item._id);
        const selectedItem = this.state.selectedItem?.editable.item;
        const selectedLaunch = selectedItem && launches.find(launch => launch._id === selectedItem?._id);
        const newLaunch = this.state.selectedItem?.type === DBDef_LaunchUrls.dbKey && !selectedLaunch?._id;
        return _jsx(TS_CollapsableContainerV2, { animated: true, forceUpdate: true, headerRenderer: () => _jsxs(_Fragment, { children: [viewsLabelMap[DBDef_LaunchUrls.dbKey], _jsx(ICONS.more.component, { ...openContent.popUpV2.bottom({
                            id: 'pop-up-menu',
                            content: this.renderLaunchUrlsMenu(),
                            offset: 10
                        }) })] }), onHeaderRightClick: e => this.onHeaderRightClick(e, this.renderLaunchUrlsMenu), containerRenderer: () => {
                if (!launches.length && !newLaunch)
                    return this.renderNoEntityFound('launch urls');
                return _jsxs(_Fragment, { children: [newLaunch &&
                            _jsx("div", { className: 'editor-organization__view selected', children: selectedItem.label }, 'NewLaunch'), launches.map(launch => {
                            const selected = launch._id === this.state.selectedItem?.editable.item._id;
                            const className = _className('editor-organization__view', selected && 'selected');
                            return _jsx("div", { className: className, onClick: () => this.selectItem(DBDef_LaunchUrls.dbKey, launch, ModuleFE_LaunchUrls), onContextMenu: e => this.onEntityRightClick(e, this.getLaunchUrlsActions(launch)), children: launch.label }, launch._id);
                        })] });
            } }, DBDef_LaunchUrls.dbKey);
    };
    // ######################## Render - Menus ########################
    renderUserMenu = () => {
        return _jsx(TS_CollapsableContainerV2, { forceUpdate: true, animated: true, headerRenderer: () => _jsx(_Fragment, { children: viewsLabelMap[DBDef_User.dbKey] }), containerRenderer: () => {
                const orgUsers = getUsersByOrganization(this.state.editable.item._id);
                if (!orgUsers.length)
                    return this.renderNoEntityFound('organization users');
                return _jsx(_Fragment, { children: orgUsers.map(user => {
                        const currentAccount = ModuleFE_Account.cache.unique(user._id);
                        const selected = currentAccount?._id === this.state.selectedItem?.editable.item._id;
                        const className = _className('editor-organization__view', selected && 'selected');
                        //filter out service accounts
                        if (currentAccount?.type === 'service')
                            return;
                        const label = currentAccount?.email ?? 'Account Deleted';
                        return _jsx("div", { className: className, onClick: () => this.selectItem(DBDef_User.dbKey, user, ModuleFE_User), children: label }, currentAccount?._id ?? user._id);
                    }) });
            } }, DBDef_User.dbKey);
    };
    renderEHRInstallationsMenu = () => {
        return _jsx(_Fragment, { children: _jsx("div", { className: 'popup-action', onClick: () => {
                    const newInstallation = { label: 'New', organizationId: this.state.editable.item._id, type: EHRInstallationTypes[0] };
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    this.selectItem(DBDef_EHRInstallation.dbKey, newInstallation, ModuleFE_EHRInstallation);
                }, children: "Add New Installation" }) });
    };
    renderEnvironmentsMenu = (installation) => {
        return _jsx(_Fragment, { children: _jsx("div", { className: 'popup-action', onClick: () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    const newEnvironment = {
                        ehrInstallationId: installation._id,
                        type: installation.type,
                        label: 'New'
                    };
                    this.selectItem(DBDef_Environment.dbKey, newEnvironment, ModuleFE_Environment);
                }, children: "Add New Environment" }) });
    };
    renderConfigurationMenu = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'popup-action', onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        const newConfiguration = {
                            label: 'New Configuration',
                            organizationId: this.state.editable.item._id,
                            contextRuleIds: [],
                            enableSurvey: false,
                            devInstance: false,
                            kbVersionId: '',
                            enableDocumentation: false,
                            enableAgl: false,
                            useEhrOrderId: false,
                            magicWand: false,
                            catchUp: { vitals: false, recap: false },
                            aglFixing: { labs: { enabled: false }, radiology: { enabled: false } },
                            noteIds: [],
                        };
                        this.selectItem(DBDef_AdvisorConfiguration.dbKey, newConfiguration, ModuleFE_AdvisorConfiguration);
                    }, children: "Add New Configuration" }), _jsx("div", { className: 'popup-action', onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        this.updateAllConfigurationsToLatestKBVersion();
                    }, children: "Update All to Latest KB Version" })] });
    };
    renderFacilityMenu = () => {
        return _jsx(_Fragment, { children: _jsx("div", { className: 'popup-action', onClick: () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    const newFacility = {
                        name: 'New facility',
                        organizationId: this.state.editable.item._id,
                    };
                    this.selectItem(DBDef_Facility.dbKey, newFacility, ModuleFE_Facility);
                }, children: "Add New Facility" }) });
    };
    renderLaunchUrlsMenu = () => {
        return _jsx(_Fragment, { children: _jsx("div", { className: 'popup-action', onClick: () => {
                    ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                    const newLaunchUrl = {
                        label: 'New Launch Url',
                        organizationId: this.state.editable.item._id,
                    };
                    this.selectItem(DBDef_LaunchUrls.dbKey, newLaunchUrl, ModuleFE_LaunchUrls);
                }, children: "Add New Launch Url" }) });
    };
    // ######################## Render - Body ########################
    renderEditor = () => {
        const organizationId = this.state.editable.item._id;
        const editMode = this.state.editMode;
        const selectedEditableItem = this.state.selectedItem?.editable;
        // New organization (no _id): only General Information is available until saved
        if (!organizationId) {
            return _jsx(Editor_Organization_GeneralInformation, { editable: this.state.editable, editMode: editMode }, 'general');
        }
        switch (this.state.selectedItem?.type) {
            case DBDef_EHRInstallation.dbKey:
                return _jsx(Editor_Organization_EHRInstallations, { organizationId: organizationId, editMode: this.state.editMode, editable: selectedEditableItem }, selectedEditableItem?.item._id);
            case DBDef_Environment.dbKey:
                const environment = selectedEditableItem;
                return _jsx(Editor_Organization_Environments, { editable: environment, ehrInstallationId: environment.item.ehrInstallationId, editMode: editMode }, environment.item._id);
            case DBDef_AdvisorConfiguration.dbKey:
                return _jsx(Editor_Organization_AdvisorConfigurations, { editable: selectedEditableItem, editMode: editMode }, selectedEditableItem?.item._id);
            case DBDef_Facility.dbKey:
                return _jsx(Editor_Organization_Facilities, { organizationId: organizationId, editable: selectedEditableItem, editMode: editMode }, selectedEditableItem?.item._id);
            case DBDef_LaunchUrls.dbKey:
                return _jsx(Editor_Organization_LaunchUrls, { organizationId: organizationId, editable: selectedEditableItem, editMode: editMode }, selectedEditableItem?.item._id);
            case DBDef_User.dbKey:
                const userId = selectedEditableItem?.item._id;
                if (!userId)
                    return;
                const user = ModuleFE_User.cache.unique(userId);
                const account = ModuleFE_Account.cache.unique(userId);
                if (!account || !user)
                    return;
                return _jsx(Component_OrganizationUserProfile, { user: user, account: account }, userId);
            default:
                if (!selectedEditableItem)
                    return _jsx(Editor_Organization_GeneralInformation, { editable: this.state.editable, editMode: editMode }, 'general');
        }
    };
}
//# sourceMappingURL=Editor_Organization.js.map